import { render, staticRenderFns } from "./investorCourt.vue?vue&type=template&id=6886747a"
import script from "./investorCourt.vue?vue&type=script&lang=js"
export * from "./investorCourt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports